"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Telegraph Public API
 * Public API offering access to Telegraph data
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: bookingsupport@telegraph.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CanadianGrainInformationGAToJSON = exports.CanadianGrainInformationGAFromJSONTyped = exports.CanadianGrainInformationGAFromJSON = exports.instanceOfCanadianGrainInformationGA = void 0;
/**
 * Check if a given object implements the CanadianGrainInformationGA interface.
 */
function instanceOfCanadianGrainInformationGA(value) {
    return true;
}
exports.instanceOfCanadianGrainInformationGA = instanceOfCanadianGrainInformationGA;
function CanadianGrainInformationGAFromJSON(json) {
    return CanadianGrainInformationGAFromJSONTyped(json, false);
}
exports.CanadianGrainInformationGAFromJSON = CanadianGrainInformationGAFromJSON;
function CanadianGrainInformationGAFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'fumigated_cleaned_indicator_code_01': json['fumigated_cleaned_indicator_code_01'] == null ? undefined : json['fumigated_cleaned_indicator_code_01'],
        'commodity_code_02': json['commodity_code_02'] == null ? undefined : json['commodity_code_02'],
        'inspected_weighed_indicator_code_03': json['inspected_weighed_indicator_code_03'] == null ? undefined : json['inspected_weighed_indicator_code_03'],
        'reference_identification_qualifier_04': json['reference_identification_qualifier_04'] == null ? undefined : json['reference_identification_qualifier_04'],
        'reference_identification_05': json['reference_identification_05'] == null ? undefined : json['reference_identification_05'],
        'week_06': json['week_06'] == null ? undefined : json['week_06'],
        'unload_terminal_elevator_code_07': json['unload_terminal_elevator_code_07'] == null ? undefined : json['unload_terminal_elevator_code_07'],
        'date_08': json['date_08'] == null ? undefined : (new Date(json['date_08'])),
        'number_09': json['number_09'] == null ? undefined : json['number_09'],
        'machine_separable_indicator_code_10': json['machine_separable_indicator_code_10'] == null ? undefined : json['machine_separable_indicator_code_10'],
        'canadian_wheat_board_cwb_marketing_class_code_11': json['canadian_wheat_board_cwb_marketing_class_code_11'] == null ? undefined : json['canadian_wheat_board_cwb_marketing_class_code_11'],
        'canadian_wheat_board_cwb_marketing_class_type_code_12': json['canadian_wheat_board_cwb_marketing_class_type_code_12'] == null ? undefined : json['canadian_wheat_board_cwb_marketing_class_type_code_12'],
        'yes_no_condition_or_response_code_13': json['yes_no_condition_or_response_code_13'] == null ? undefined : json['yes_no_condition_or_response_code_13'],
        'location_identifier_14': json['location_identifier_14'] == null ? undefined : json['location_identifier_14'],
        'state_or_province_code_15': json['state_or_province_code_15'] == null ? undefined : json['state_or_province_code_15'],
        'percent_qualifier_16': json['percent_qualifier_16'] == null ? undefined : json['percent_qualifier_16'],
        'percentage_as_decimal_17': json['percentage_as_decimal_17'] == null ? undefined : json['percentage_as_decimal_17'],
        'yes_no_condition_or_response_code_18': json['yes_no_condition_or_response_code_18'] == null ? undefined : json['yes_no_condition_or_response_code_18'],
    };
}
exports.CanadianGrainInformationGAFromJSONTyped = CanadianGrainInformationGAFromJSONTyped;
function CanadianGrainInformationGAToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'fumigated_cleaned_indicator_code_01': value['fumigated_cleaned_indicator_code_01'],
        'commodity_code_02': value['commodity_code_02'],
        'inspected_weighed_indicator_code_03': value['inspected_weighed_indicator_code_03'],
        'reference_identification_qualifier_04': value['reference_identification_qualifier_04'],
        'reference_identification_05': value['reference_identification_05'],
        'week_06': value['week_06'],
        'unload_terminal_elevator_code_07': value['unload_terminal_elevator_code_07'],
        'date_08': value['date_08'] == null ? undefined : ((value['date_08']).toISOString()),
        'number_09': value['number_09'],
        'machine_separable_indicator_code_10': value['machine_separable_indicator_code_10'],
        'canadian_wheat_board_cwb_marketing_class_code_11': value['canadian_wheat_board_cwb_marketing_class_code_11'],
        'canadian_wheat_board_cwb_marketing_class_type_code_12': value['canadian_wheat_board_cwb_marketing_class_type_code_12'],
        'yes_no_condition_or_response_code_13': value['yes_no_condition_or_response_code_13'],
        'location_identifier_14': value['location_identifier_14'],
        'state_or_province_code_15': value['state_or_province_code_15'],
        'percent_qualifier_16': value['percent_qualifier_16'],
        'percentage_as_decimal_17': value['percentage_as_decimal_17'],
        'yes_no_condition_or_response_code_18': value['yes_no_condition_or_response_code_18'],
    };
}
exports.CanadianGrainInformationGAToJSON = CanadianGrainInformationGAToJSON;
